"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@ledgerhq/errors");
const rxjs_1 = require("rxjs");
const deviceAccess_1 = require("../../hw/deviceAccess");
const derivation_1 = require("@ledgerhq/coin-framework/derivation");
const getAddress_1 = __importDefault(require("../../hw/getAddress"));
const receive = (account, { deviceId, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => {
    return new rxjs_1.Observable(o => {
        void (function () {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const r = yield (0, getAddress_1.default)(transport, {
                        derivationMode: account.derivationMode,
                        currency: account.currency,
                        path: account.freshAddressPath,
                        segwit: (0, derivation_1.isSegwitDerivationMode)(account.derivationMode),
                    });
                    if (r.publicKey !== account.seedIdentifier) {
                        throw new errors_1.WrongDeviceForAccount(`WrongDeviceForAccount ${account.name}`, {
                            accountName: account.name,
                        });
                    }
                    o.next({
                        address: account.freshAddress,
                        path: account.freshAddressPath,
                    });
                    o.complete();
                }
                catch (err) {
                    o.error(err);
                }
            });
        })();
    });
});
exports.default = receive;
//# sourceMappingURL=js-receive.js.map